import React from 'react';
import classNames from 'classnames';

export default function EmailIcon({ className = '' }) {
	return <span className={classNames('icon icon-email', className)} />;
}
